/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiUpdateWaveDecisionPause {
    /**
    * null when new pause is created. Only supply when editing a pause.
    */
    'id': number | null;
    /**
    * Decisions after this time will not be made. Should not overlap with other pauses. Needs to be in the future. Can not be updated after pause creation.
    */
    'start_time': number;
    /**
    * Decisions before this time will not be made. Should not overlap with other pauses. Needs to be after start_time, after now and after wave.next_decision_time
    */
    'end_time': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "start_time",
            "baseName": "start_time",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "end_time",
            "baseName": "end_time",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiUpdateWaveDecisionPause.attributeTypeMap;
    }

    public constructor() {
    }
}

